import dayjs from "dayjs";
import { isNil } from "lodash-es";

export const formatMoney = (money?: number | string | null) => {
  if (isNil(money)) return "";
  return Number(money).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

export const formatToPercent = (
  value?: number | null,
  options: Intl.NumberFormatOptions = {},
) => {
  if (!value) return "";

  const percentOptions = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    ...options,
  };

  if (value > 1) {
    const formattedValue = (value / 100).toLocaleString("pt-br", {
      ...percentOptions,
      style: "percent",
    });
    return formattedValue;
  } else {
    const formattedValue = value.toLocaleString("pt-br", {
      ...percentOptions,
    });
    return `${formattedValue}%`;
  }
};

export const formatTax = (value?: number) => {
  if (!value) return 0;

  const val = (value * 100).toFixed(2);

  return Number(val);
};

export const formatToNumberStr = (value?: string | null) => {
  return value?.replace(/\D/g, "");
};

export const formatToNumber = (value: string) => {
  return value ? Number(formatToNumberStr(value)) : 0;
};

export const formatDate = (date: dayjs.ConfigType, formatStr: string) => {
  if (!date) return "";
  return dayjs(date).format(formatStr);
};

export const formatCEP = (cep?: string | number | null) => {
  if (!cep) return "";

  return cep
    .toString()
    .replace(/\D/g, "")
    .replace(/^(\d{5})(\d)/, "$1-$2");
};

export const formatPhone = (phone?: string | number | null) => {
  if (!phone) return "";

  return phone
    .toString()
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3");
};

export const formatCpf = (cpf?: string) => {
  return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") || "";
};

export const formatMonthAmount = (months?: number) => {
  if (typeof months === "undefined") return "";
  return `${months} ${months === 1 ? "mês" : "meses"}` as const;
};

export const formatOriginUrl = (url?: string) => {
  if (!url) return "";
  if (url.startsWith("http")) {
    return new URL(url).origin;
  } else {
    return new URL(`${location.protocol}//${url}`).origin;
  }
};

export const formatISODate = (date?: string): dayjs.Dayjs | null => {
  let _date = date?.trim();
  const brDateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})/;
  if (_date && (brDateRegex.test(_date) || isoDateRegex.test(_date))) {
    if (brDateRegex.test(_date)) {
      const [day, month, year] = _date.split("/");
      _date = `${year}-${month}-${day}`;
    } else {
      _date = _date.split("T")[0];
    }
    return dayjs(_date);
  }
  return null;
};

export const calculateAge = (
  dateOfBirth?: dayjs.ConfigType,
  unit?: dayjs.QUnitType,
): number => {
  if (!dateOfBirth) {
    return 0;
  }

  const today = dayjs();
  const age = today.diff(dateOfBirth, unit ?? "years");

  return age;
};
